import { setData } from "rivals/shared/utils/qa";
import styles from "./PageHeader.module.scss";
import type { Props } from "./types";

const PageHeader = ({
  ad,
  data = "header",
  headerLink,
  headerColor,
  headerImage,
  pageTitle,
  secondLevelRightSection,
  thirdLevel,
  subtitle
}: Props): JSX.Element => {
  const areAdsAvailable = !!ad;

  const subTitle = (
    <h2 className={styles.subtitle} style={{ color: `#${headerColor}` }}>
      {subtitle}
    </h2>
  );

  const title = (
    <h1
      className={headerColor ? styles.coloredTitle : styles.title}
      style={{ color: `#${headerColor}` }}
    >
      {pageTitle}
    </h1>
  );

  const leftSection = (
    <div className={styles.leftSection}>
      {!!headerImage && <div className={styles.headerImage}>{headerImage}</div>}
      <div>
        {!!subtitle && subTitle}
        {title}
        {!!headerLink && <div className={styles.headerLink}>{headerLink}</div>}
      </div>
    </div>
  );

  const rightSection = !!secondLevelRightSection && (
    <div className={styles.rightSection}>{secondLevelRightSection}</div>
  );

  return (
    <div {...setData(data, "wrapper")}>
      {areAdsAvailable && (
        <div className={styles.fstLevel} {...setData(data, "first-level")}>
          {ad}
        </div>
      )}
      <div className={styles.sndLevel} {...setData(data, "second-level")}>
        {leftSection}
        {rightSection}
      </div>
      {!!thirdLevel && (
        <div className={styles.thrdLevel} {...setData(data, "third-level")}>
          {thirdLevel}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
